import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqItems } from '../data/faq';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full border-t border-line bg-panel py-20 sm:py-28" data-id="element-21" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-read px-4" data-id="element-22" data-mp="1gal2xrndzzfc">
        <h2 id="faq-titulo" className="font-display text-3xl font-bold uppercase tracking-tight text-bone sm:text-4xl" data-id="element-23" data-mp="2e0pn5d72816u">
          Lo que suelen preguntarme
        </h2>

        <div className="mt-10 divide-y divide-line border-y border-line" data-id="element-24" data-mp="241gwoubel4p8">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-25" data-mp="snmp71qnj5l4" data-mpi={index}>
                <h3 data-id="element-26" data-mp="soejm98iix9t">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-5 text-left" data-id="element-27" data-mp="skqpp8z5o8uk">
                    <span className="text-lg font-semibold text-bone" data-id="element-28" data-mp="fiqdg2wbaosj">{item.question}</span>
                    <PlusIcon aria-hidden="true" className={`mt-1 h-5 w-5 shrink-0 text-lime transition-transform duration-150 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-29" data-mp="ki1vrgcbu2c8" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-30" data-mp="3t07so3wrpg48">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-31" data-mp="1tesn3dpnn1a">
                      <p className="pb-6 pr-10 leading-relaxed text-mute" data-id="element-32" data-mp="1ppcn9cq2wj7p">{item.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}